import { render, staticRenderFns } from "./ask.vue?vue&type=template&id=2dc72176&scoped=true&"
import script from "./ask.vue?vue&type=script&lang=js&"
export * from "./ask.vue?vue&type=script&lang=js&"
import style0 from "./ask.vue?vue&type=style&index=0&id=2dc72176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc72176",
  null
  
)

export default component.exports